export class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.onCartRequestEnd = this.onCartRequestEnd.bind(this);
    this.onInteractiveClick = this.onInteractiveClick.bind(this);
  }

  connectedCallback() {
    document.addEventListener('liquid-ajax-cart:request-end', this.onCartRequestEnd);
    this.addEventListener('click', this.onInteractiveClick);
  }

  disconnectedCallback() {
    document.removeEventListener('liquid-ajax-cart:request-end', this.onCartRequestEnd);
    this.removeEventListener('click', this.onInteractiveClick);
  }

  /**
   * Immediate press feedback for qty +/- and remove while the AJAX cart request runs.
   * @param {MouseEvent} event
   */
  onInteractiveClick(event) {
    const target = event.target;
    if (!(target instanceof Element)) {
      return;
    }

    const qtyControl = target.closest(
      '[data-ajax-cart-quantity-minus], [data-ajax-cart-quantity-plus]'
    );
    if (qtyControl) {
      const quantity = qtyControl.closest('ajax-cart-quantity');
      quantity?.classList.add('is-updating');
      return;
    }

    const remove = target.closest('.cart-drawer__product-remove');
    if (remove) {
      remove.classList.add('is-updating');
    }
  }

  onCartRequestEnd(event) {
    this.querySelectorAll('ajax-cart-quantity.is-updating, .cart-drawer__product-remove.is-updating').forEach(
      (el) => el.classList.remove('is-updating')
    );

    const { requestState } = event.detail || {};
    if (requestState?.requestType === 'add' && requestState?.responseData?.ok) {
      // Open cart drawer via Alpine on header
      window.dispatchEvent(new CustomEvent('cart-open'));
    }
  }
}

if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', CartDrawer);
}
